import React, { useState, useEffect } from 'react';
import useInterval from '../../customHooks/useInterval.js';
import BezierEasing from 'bezier-easing';

const FameMeter = props => {
    const [scoreToEase, setScoreToEase] = useState(0);
    const [timeoutClock, setTimeoutClock] = useState(0);
    const INTERVAL_RATE = 20;
    
    const easeInOut = BezierEasing(.42,0,.58,1); // using the css ease-in-out bezier here
    const scoreEase = easeInOut(scoreToEase)*props.totalScore/100
    const mappedScoreEase = scoreEase*100;

    const overlayStyle = {
        left: `${mappedScoreEase}%`
    }
    const indicatorStyle = {
        left: `${mappedScoreEase}%`,
        transform: 'translateX(-26px)' // offset indicator position by roughly half its width
    }
    useInterval(() => {
        if (timeoutClock < props.data.animationTimeout) {
            setTimeoutClock(timeoutClock+INTERVAL_RATE);
            return
        }
        if (scoreToEase < 1) {
            setScoreToEase(scoreToEase+.01);
        }
    }, INTERVAL_RATE)

    return (
        <div className={`FameMeter`}>
            <div className={`title`}>{props.data.title.toUpperCase()}</div>
            <div className={`left-percentage`}>{props.data.leftPercent}</div>
            <div className={`right-percentage`}>{props.data.rightPercent}</div>
            <div className={`meter`}>
                <div className={`road`} />
                <div className={`white-overlay`} style={overlayStyle} />
            </div>
            <div className={`percentage-indicator`} style={indicatorStyle} dangerouslySetInnerHTML={{__html:`<p>${Math.floor(mappedScoreEase)}%</p>`}} />
        </div>
    )
}

export default FameMeter